import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import RenderField from './renderField';

const Form = ({ onSubmit }) => {
  const { t } = useTranslation('deliveries');
  const { handleSubmit, control, trigger, formState: { isSubmitting, errors, isValid, isDirty } } = useFormContext();

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="order-details">
      <div className="order-details__content">

        <h3>{t('findDelivery.form.header')}</h3>
        
        <div className="form-row">
          <Controller
            name="deliveryId"
            control={control}
            rules={{
              required: { value: true, message: 'error1' },
              maxLength: { value: 11, message: 'error2' },
              pattern: { value: /^(?:d|o|r)\d+$/i, message: 'error3' }
            }}
            render={({ field, fieldState }) => {
              const onChange = (e) => {
                field.onChange(e);
                trigger(field.name);
              };

              return (
              <RenderField
                field={{ ...field, onChange }}
                fieldState={fieldState}
                label={t('findDelivery.form.label1')}
                type="tel"
                placeholder={t('findDelivery.form.placeholder1')}
                t={t}
              />
            );
          }}
          />
        </div>

        <div className="form-row">
          <Controller
            name="mobileNo"
            control={control}
            rules={{
              required: { value: true, message: 'mobileNo' }
            }}
            render={({ field, fieldState }) => {
              const onChange = (e) => {
                field.onChange(e);
                trigger(field.name);
              };

              return (
              <RenderField
                field={{ ...field, onChange }}
                fieldState={fieldState}
                label={t('findDelivery.form.label2')}
                type="tel"
                placeholder="07X - XXX XX XX"
                t={t}
              />
            );
          }}
        />
      </div>

        {errors.root && (
          <span className="help-text help-text--has-error">{errors.root.message}</span>
        )}

        <button 
          className="btn btn--primary btn--block" 
          type="submit" 
          disabled={!isDirty || isSubmitting || !isValid}
        >
          {t('findDelivery.form.button')}
        </button>

      </div>
    </form>
  );
};

export default Form;
